export default __webpack_public_path__ + "static/media/edge_challenge.ae5e9141.png";